import { Grid } from '@mui/material';
import SummaryTables from 'src/components/SummaryTables';

const ReviewDifferenceTable = ({ headers, values }) => {
  const { original, updated } = values;

  return (
    <Grid container spacing={2}>
      <SummaryTables title="Original" headers={headers} rows={original} />
      <SummaryTables title="Updated" headers={headers} rows={updated} />
    </Grid>
  );
};

export default ReviewDifferenceTable;
